import { format } from "date-fns";
import { useState } from "react";
import Button from "src/components/button/Button";
import Show from "src/components/film/program/Show";
import FilmwebLink from "src/components/filmweblink/FilmwebLink";
import Kinoklubb from "src/components/kinoklubb/Kinoklubb";
import MoviePosterImage from "src/components/program/MoviePosterImage";
import { useProgramDatesContext } from "src/lib/contexts/ProgramDatesWrapper";
import classNames from 'classnames';
import { ProgramMovie } from "src/lib/types/filminfo/ProgramMovie";
import { ProgramShow } from "src/lib/types/filminfo/ProgramShow";
import styles from './ProgrammedMovie.module.css';

//#region [Props]
type ProgrammedMovieProps = {
    movie: ProgramMovie;
};
//#endregion

//#region [Component]
export default function ProgrammedMovie({ movie }: ProgrammedMovieProps) {
    const selectedDateContext = useProgramDatesContext();
    const [isExpanded, setIsExpanded] = useState(false);

    const selDate = selectedDateContext?.selectedDate ? `#${format(selectedDateContext.selectedDate, 'dd.MM.yyyy')}` : '';
    let genres = movie.genres;
    if (genres?.includes("Barnefilm") && genres?.includes("Familiefilm")) {
        genres = genres.filter(g => g !== "Barnefilm");
    }
    return <article className={styles.SMovieContainer}>
        <div className={styles.SMovie}>
            <FilmwebLink className={styles.SPosterContainerLink} to={`/film/${movie.mainVersionId}${selDate}`}>
                <MoviePosterImage className={styles.SPosterImage} movie={movie} missingPosterOffCentre />
            </FilmwebLink>
            <div className={styles.SInfo}>
                <FilmwebLink className={styles.STitleLink} to={`/film/${movie.mainVersionId}${selDate}`}><h1 className={styles.SMovieTitle}>{movie.title}</h1></FilmwebLink>
                <div className={styles.SFacts}>
                    <div className={styles.SNoWrap}>{movie.rating}</div>
                    {!!movie.lengthInMinutes && <div className={styles.SNoWrap}>
                        {Math.floor(movie.lengthInMinutes / 60) > 0 ? `${Math.floor(movie.lengthInMinutes / 60)}t ` : null}
                        {`${movie.lengthInMinutes - 60 * Math.floor(movie.lengthInMinutes / 60)}m`}
                    </div>}
                    {(genres?.length ?? 0) > 0 && <div className={styles.SGenre}>{genres!.join(" / ")}</div>}
                </div>
                {movie.isKinoklubb && areAnyShowsKinoklubb(movie.filteredShows) && <Kinoklubb className={styles.SKinoklubb} />}
                <div className={styles.SProgram}>
                    {movie.filteredShows?.slice(0, 3)?.map((show, index) => <Show
                        key={show?.ticketSaleUrl ?? index}
                        show={show!}
                        isKinoklubbMovie={movie.isKinoklubb} />)}
                    {(movie.filteredShows?.length ?? 0) > 3 && <div className={classNames(styles.SExpander, {
                        [styles.expanded]: isExpanded
                    })}>
                        {movie.filteredShows?.slice(3)?.map((show, index) => <Show
                            key={show?.ticketSaleUrl ?? index}
                            show={show!}
                            isKinoklubbMovie={movie.isKinoklubb} />)}
                    </div>}
                </div>
                <div className={styles.SLinks}>
                    <FilmwebLink className={styles.SReadMoreLink} to={`/film/${movie.mainVersionId}${selDate}`}>Les mer</FilmwebLink>
                    {(movie.filteredShows?.length ?? 0) > 3 && <Button text={isExpanded ? "Færre forestillinger" : "Flere forestillinger"} onClick={() => setIsExpanded(!isExpanded)} inverse />}
                </div>
            </div>
        </div>
    </article>;
}
//#endregion

//#region [Other] Helpers
function areAnyShowsKinoklubb(shows: ProgramShow[] | undefined | null) {
    return shows?.some(show => show.isKinoklubb) ?? false;
}
//#endregion

